module.exports = __webpack_public_path__ + "img/like.0a8686bf.svg";